import React from 'react';
import { Shield, Lock, Eye, Server } from 'lucide-react';

const EncryptedEmailSection = () => {
  const encryptionFeatures = [
    {
      icon: Shield,
      title: 'True zero-access encryption model',
      description: 'Emails are encrypted directly on your device before transmission. No one, including our system, can ever access or decrypt your content.',
    },
    {
      icon: Lock,
      title: 'Complete end-to-end message protection',
      description: 'All communications remain encrypted throughout the entire delivery process, ensuring uninterrupted privacy from sender to recipient.',
    },
    {
      icon: Eye,
      title: 'Strict no-tracking privacy policy',
      description: 'We do not scan emails, collect data, or build behavioral profiles. Your communication stays fully private and untouched.',
    },
    {
      icon: Server,
      title: 'Highly secured infrastructure environment',
      description: 'Our servers are hosted in privacy-oriented regions and protected with advanced physical and digital security systems.',
    },
  ];

  return (
    <section className="py-20 bg-cover bg-center bg-no-repeat text-white relative overflow-hidden" style={{ backgroundImage: "url('/assets/banner-bg-img.jpg')" }}>
      {/* Background overlay */}
      <div className="absolute inset-0 bg-[#032a60]/80"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Next-generation encrypted email architecture
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Vaulted Mails uses multi-layer encryption systems and advanced security protocols to ensure complete confidentiality of all communications.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {encryptionFeatures.map((feature, index) => (
            <div
              key={index}
              className="group relative"
            >
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 h-full border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
                <div className="mb-6">
                  <div className="w-14 h-14 bg-[#d28f28] rounded-lg flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                    <feature.icon className="h-7 w-7 text-white" strokeWidth={2.5} />
                  </div>
                </div>
                
                <h3 className="text-xl font-bold mb-3">
                  {feature.title}
                </h3>
                
                <p className="text-white/80 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-8 py-4">
            <Lock className="h-6 w-6 text-[#d28f28]" />
            <span className="text-lg font-semibold">AES-256 Encryption Standard</span>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#d28f28] rounded-full filter blur-3xl opacity-10 animate-pulse" style={{ animationDuration: '5s' }}></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#032a60] rounded-full filter blur-3xl opacity-10 animate-pulse" style={{ animationDuration: '7s' }}></div>
    </section>
  );
};

export default EncryptedEmailSection;